<template>
  <router-view />
</template>

<script>
export default {
  name: "Portal",
}
</script>
